export type Lang = "sr" | "en";

export const translations = {
  sr: {
    // Month names (full)
    monthNames: ["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"] as string[],
    // Days of week abbreviations (Mon–Sun)
    dow: ["P","U","S","Č","P","S","N"] as string[],
    // 3-letter month abbreviations
    shortMonths: ["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"] as string[],
    // Dow for mini-calendar
    dowMini: ["Po","Ut","Sr","Če","Pe","Su","Ne"] as string[],

    // Calendar / availability
    free: "Slobodno",
    occupied: "Zauzeto",
    notAvailable: "Nije dostupno",
    notAvailableEvent: "Nije dostupno (poseban događaj)",
    notAvailableBooking: "Nije dostupno za rezervaciju",
    checkoutDateHint: "Datum odjave — tapnite da odaberete kao datum odlaska",
    pastDate: "Prošli datum",

    // Legend
    discount: "Popust",
    specialPrice: "Posebna cijena",
    standardPrice: "Standardna cijena",
    selected: "Odabrano",

    // Checkin/checkout
    checkIn: "Dolazak",
    checkOut: "Odlazak",
    nights: "Noći",
    night: "noć",
    nightPlural: "noći",
    day: "dan",
    days: "dana",

    // Booking
    apartment: "Apartman",
    total: "Ukupno",
    book: "Rezerviši",
    newBooking: "Nova rezervacija",
    reservationSent: "Rezervacija uspješno poslana!",
    thankYouFull: "Hvala vam! Vaša rezervacija je primljena i čeka potvrdu. Kontaktiraćemo vas putem emaila ili telefona.",
    thankYouShort: "Hvala vam! Kontaktiraćemo vas putem emaila ili telefona.",
    depositInfo: "💳 Uplatite avans (30%) da potvrdite rezervaciju",
    depositAmount: "Iznos avansa:",
    remainingAtCheckIn: "Preostalo pri dolasku:",
    recipient: "Primalac:",
    address: "Adresa:",
    accountNumber: "Broj računa:",

    // Form fields
    fullName: "Ime i prezime *",
    email: "Email",
    phone: "Telefon *",
    note: "Napomena",
    namePlaceholder: "npr. Marija Kostić",
    adults: "Odrasli",
    children: "Djeca",
    noteOptional: "Napomena (opcionalno)",

    // Copy URL
    copyUrl: "Kopiraj URL",

    // Promo code
    promoCode: "Promo kod",
    apply: "Primijeni",

    // Apartment listing / search
    noApartmentsAvailable: "Nema slobodnih apartmana",
    noResults: "Nema rezultata",

    // Status strings
    sending: "Slanje...",
    selectDates: "Odaberi termine",
    upcoming: "Uskoro",
    expiresToday: "Ističe danas",
    availableDeal: "Dostupna akcija",
    availableDeals: "dostupne akcije",
    noThanksBookWithout: "Ne, hvala — rezerviši bez akcije",
    review: "Pregledaj",
    notApplied: "nisu primijenjene",
    perNightTotal: "/noć · ukupno",
    more: "Još",

    // Validation / error messages
    enterName: "Unesite vaše ime",
    enterPhone: "Unesite broj telefona",
    selectCheckInCheckOut: "Odaberite datume dolaska i odlaska",
    errorSendingReservation: "Greška pri slanju rezervacije. Pokušajte ponovo.",
    apartmentNotFound: "Apartman nije pronađen",
    apartmentNotActive: "Ovaj apartman ne postoji ili nije aktivan",

    // Back navigation
    back: "Nazad",

    // PublicMenu strings
    foodOrder: "Narudžba hrane",
    select: "Odaberite",
    addToOrder: "Dodaj u narudžbu",
    yourOrder: "Vaša narudžba",
    sendOrder: "Pošalji narudžbu",
    fullNameUnstarred: "Ime i prezime",
    roomApartment: "Soba / Apartman",
    orderSent: "Narudžba poslana!",
    thankYou: "Hvala",
    orderReceived: "Narudžba primljena!",
  },
  en: {
    monthNames: ["January","February","March","April","May","June","July","August","September","October","November","December"] as string[],
    dow: ["M","T","W","T","F","S","S"] as string[],
    shortMonths: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"] as string[],
    dowMini: ["Mo","Tu","We","Th","Fr","Sa","Su"] as string[],

    free: "Available",
    occupied: "Occupied",
    notAvailable: "Not available",
    notAvailableEvent: "Not available (special event)",
    notAvailableBooking: "Not available for booking",
    checkoutDateHint: "Check-out date — tap to select as departure",
    pastDate: "Past date",

    discount: "Discount",
    specialPrice: "Special price",
    standardPrice: "Standard price",
    selected: "Selected",

    checkIn: "Check-in",
    checkOut: "Check-out",
    nights: "Nights",
    night: "night",
    nightPlural: "nights",
    day: "day",
    days: "days",

    apartment: "Apartment",
    total: "Total",
    book: "Book",
    newBooking: "New booking",
    reservationSent: "Reservation successfully sent!",
    thankYouFull: "Thank you! Your reservation has been received and is awaiting confirmation. We will contact you by email or phone.",
    thankYouShort: "Thank you! We will contact you by email or phone.",
    depositInfo: "💳 Pay a deposit (30%) to confirm your reservation",
    depositAmount: "Deposit amount:",
    remainingAtCheckIn: "Remaining at check-in:",
    recipient: "Recipient:",
    address: "Address:",
    accountNumber: "Account number:",

    fullName: "Full name *",
    email: "Email",
    phone: "Phone *",
    note: "Note",
    namePlaceholder: "e.g. Maria Smith",
    adults: "Adults",
    children: "Children",
    noteOptional: "Note (optional)",

    copyUrl: "Copy URL",

    promoCode: "Promo code",
    apply: "Apply",

    noApartmentsAvailable: "No apartments available",
    noResults: "No results",

    sending: "Sending...",
    selectDates: "Select dates",
    upcoming: "Coming soon",
    expiresToday: "Expires today",
    availableDeal: "Available deal",
    availableDeals: "available deals",
    noThanksBookWithout: "No thanks — book without a deal",
    review: "Review",
    notApplied: "not applied",
    perNightTotal: "/night · total",
    more: "More",

    enterName: "Enter your name",
    enterPhone: "Enter your phone number",
    selectCheckInCheckOut: "Please select check-in and check-out dates",
    errorSendingReservation: "Error sending reservation. Please try again.",
    apartmentNotFound: "Apartment not found",
    apartmentNotActive: "This apartment does not exist or is not active",

    back: "Back",

    foodOrder: "Food Order",
    select: "Select",
    addToOrder: "Add to order",
    yourOrder: "Your order",
    sendOrder: "Send order",
    fullNameUnstarred: "Full name",
    roomApartment: "Room / Apartment",
    orderSent: "Order sent!",
    thankYou: "Thank you",
    orderReceived: "Order received!",
  },
} as const;

export type TranslationKey = keyof typeof translations.sr;
